export function isPlayableNarrationManifestStatus(
	status: string | undefined,
): boolean {
	if (status == null) {
		return true;
	}
	return status === "READY" || status === "STALE" || status === "PARTIAL";
}
